'use strict'

export let norwegian={
  reason: {
    title:"Hvem trenger hva og hvorfor?",
    fields: {
      name: {
        title: "Prosjektnavn",
        description: "Et beskrivende navn på prosjektet",
        help: "Fortell meg om prosjektet du har i tankene."
      },
      objectives: {
        title: "Forretningsmål",
        help: `Hvilke muligheter går vi etter?
          Hvilket forretningsbehov skal prosjektet adressere?
          Hva er det vi prøver fikse, forbedre eller løse?
          Hvordan vil dette prosjektet gjøre det mulig for organisasjonen å betjene sine kunder bedre?`,
        description: "Grunnen til å gjennomføre prosjektet"
      },
      deliverables: {
        title: "Prosjektleveranser og omfang",
        help: `Disse spørsmålene omhander produktet eller tjenesten som skal produseres: “Hvis vi hadde det på plass akkurat nå [prosessen, systemet, produktet, en ny tjeneste] …”

          Hva ville du se som de viktigste funksjonene eller egenskapene?
          Hvilken tilnærming passer best? Vi vil gjøre det en gang, og hvis vi erstatter det, så vil vi starte helt på nytt igjen? Eller prøver vi å gjøre noe som skal vedlikeholdes og forbedres over tid?
          Hva er det absolutt minste som kan leveres?
          Hvordan vil det se ut fysisk?`,
        description: "Kvaliteten på leveranser og prosjektomfang"
      },
      outcomes: {
        title: "Forretningsresultat",
        help: `Disse spørsmålene er rettet mot å identifisere verdiøkende pengemessige fordelene som prosjektets leveranse skal gi. “Forutsett at vi hadde fullført prosjektet, og leveransen var på plass…”:

          Hva er den viktigste gevinsten du ønsker å oppnå? Økt omsetning? bedre kundeservice? Større markedsandel? Reduserte kostnader ved ordinær drift? Kortsiktig profitt?
          Hvordan vil du kvantifisere pengeverdien av lønnsomheten du sikter mot? ROI? Reduserte kostnader? I løpet av hvilken tidsperiode?
          Hva ønsker du å se forretningsfordelen av å ha oppnådd?
          Under hvilke omstendigheter bør prosjektet stoppes?`,
        description:"Forventet resultat av prosjektet"
      }
    }
  },
  surroundings: {
    title:"Omgivelsene",
    fields: {
      context: {
        title:"Sammenheng",
        help: `Disse spørsmålene vil avdekke informasjon om virksomhetens klima rundt prosjektet.

          Hvordan vil dette prosjektet passe inn i organisasjonens overordnede forretningsstrategi?
          Hvem kjører dette prosjektet ovenfra?
          Hvem vil du gå til for godkjenning og finansiering?
          Hva driver oss til dette nå? Hva hvis vi ikke gjør noe? Vente til neste år?
          Hvordan passer dette inn i den generelle prioriteringen av prosjekter?
          Hvis vi må la et annet prosjekt skli, hva vil det være?`,
        description:"I hvilken sammenheng eksisterer prosjektet"
      },
      stakeholders: {
        title: "Interessenter",
        help:`Disse spørsmålene er knyttet til politikken i prosjektet. her vil du fnne ut hvem prosjektet er ment å påirke, til det bedre eller værre. De rammende kan være interne eller eksterne i forhold til organisasjonen.

          For hvem blir projektet gjennomført?
          Hvilken kundegruppe eller avdeling er prosjktet tiltenkt å påvirke?
          Hvem vil føle seg truet av dette prosjektet eller har sterke meninger?
          Hvem trenger vi å snakke med som må være fornøyd med resultatene?
          Hvem er de største tilhengerne av dette prosjektet?`,
        description: "Hvem er berørt av prosjektet"
      }
    }
  },
  dependencies: {
    title: "Avhengigheter",
    fields: {
      timing: {
        title:"Tid",
        help:`Hvilken tidsramme eller frist har du tenkt på?
          Hva styrer tidsfristen?
          Hvilket slingringsmonn finnes?`,
        description:"I hvilken tidsperiode vil prosjektet bli utført"
      },
      resources: {
        title:"Ressurser og budsjett",
        help:`Hva forventer du å bruke på prosjektet?
          Hvilket budsjett kommer midlene fra?
          Hvem skal jeg snakke med for å få prosjektdeltakere?`,
        description: "Hva kreves for å kjøre prosjektet"
      },
      tradeOffs: {
        title: "Avveiinger",
        help:`Når avveininger må gjøres, hvilket av prosjektets vilkår må oppfylles (eller, hvilket vilkår må for all del ikke ofres)?
          ROI (Return On Investment - avkastning av investeringen), tidsplan, budsjett, funksjoner og egenskaper, kvalitet, kunde- interesent-tilfredshet, team-tilfredshet?
          Hva er det nest viktigste vilkåret?`,
        description:"Hva er prioritetene"
      }
    }
  },
  relationship: {
    title: "Relasjoner",
    fields: {
      relations: {
        title:"Samarbeid",
        help:`Hvordan ser du på din rolle i forhold til beslutningsprosesser? Finansiering? Bemanning? Hvem andre vil du forhøre deg med for dette?
          Hvordan ser du på min rolle i prosjektet?
          Hvilken informasjon er viktig for deg i forhold til fremdriftsrapportering?`,
        description: "Hva er forventningene til deg som ansvarlig for prosjektet"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./views/extremeProject/labels/norwegian.js